import { Phone, Mail, MapPin } from "lucide-react";
import logo from '../image/logo.png';

import { NavLink } from 'react-router-dom';



export function Header() {
  return (
			<>
				<nav class='navbar sticky-top border-bottom navbar-light bg-light'>
					<div class='container-fluid'>
						<div class='container'>
							<div class='row'>
								<div class='col'>
									<Phone size={16} color='#020202' />
									&nbsp;
									<a href='tel:0618767935' style={{ color: '#000', textDecoration: 'none' }}>
										06.18.76.79.35 /
									</a>
									<a href='tel:0664345036' style={{ color: '#000', textDecoration: 'none' }}>
										{' '}
										06.64.34.50.36
									</a>
								</div>
								<div class='col-6'>
									<Mail size={16} color='#020202' />
									&nbsp;
									<a href='mailto:epavistemoro@gmail.com' style={{ color: '#000', textDecoration: 'none' }}>
										epavistemoro@gmail.com
									</a>
								</div>
								<div class='col'>
									<MapPin size={16} color='#fe0101' />
									&nbsp; Pays Basque • Béarn • Landes
								</div>
							</div>
						</div>
					</div>
				</nav>
				<nav class='navbar sticky-top navbar-expand-lg navbar-light bg-light'>
					<a class='navbar-brand mx-5' href='/'>
						<img src={logo} alt=' logo moro epaviste' width='150' height='90' class='d-inline-block align-text-top' />
						<b>Épaviste Moro</b>
						<br />
						<b>Dépannage • Épaviste • Débarras</b>
					</a>
					<button
						class='navbar-toggler'
						type='button'
						data-toggle='collapse'
						data-target='#navbarTogglerDemo02'
						aria-controls='navbarTogglerDemo02'
						aria-expanded='false'
						aria-label='Toggle navigation'
					>
						<span class='navbar-toggler-icon'></span>
					</button>

					<div class='collapse navbar-collapse' id='navbarTogglerDemo02'>
						<ul class='navbar-nav mr-auto mt-2 mt-lg-0 justify-content-end'>
							<li class='nav-item active px-2'>
								<NavLink
									to='/'
									style={({ isActive, isPending }) => {
										return {
											fontWeight: isActive ? 'bold' : '',
											color: isActive ? 'red' : 'black',
											textDecoration: isActive ? 'none' : 'none',
										};
									}}
								>
									Accueil
								</NavLink>
							</li>
							<li class='nav-item px-3'>
								<NavLink
									to='/services'
									style={({ isActive, isPending }) => {
										return {
											fontWeight: isActive ? 'bold' : '',
											color: isActive ? 'red' : 'black',
											textDecoration: isActive ? 'none' : 'none',
										};
									}}
								>
									Services
								</NavLink>
							</li>
							<li class='nav-item px-3'>
								<NavLink
									to='/Commentçamarche'
									style={({ isActive, isPending }) => {
										return {
											fontWeight: isActive ? 'bold' : '',
											color: isActive ? 'red' : 'black',
											textDecoration: isActive ? 'none' : 'none',
										};
									}}
								>
									Comment ça marche
								</NavLink>
							</li>

							<li class='nav-item px-3'>
								<NavLink
									to='/Contact'
									style={({ isActive, isPending }) => {
										return {
											fontWeight: isActive ? 'bold' : '',
											color: isActive ? 'red' : 'black',
											textDecoration: isActive ? 'none' : 'none',
										};
									}}
								>
									Contact
								</NavLink>
							</li>
						</ul>
					</div>
				</nav>
			</>
		);
}
